import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { RouteError } from "@/shared/components/RouteError";

export const Route = createFileRoute("/app/admin/kpis")({
  beforeLoad: ({ context }) => {
    // BEL-884: platform-plane view — same condition as the menu link in
    // navigation.platform.ts. reporting.kpiOps.read is also held by customer
    // managers, so it cannot be the gate.
    if (context.auth.user?.platformAdmin !== true) {
      throw redirect({ to: "/app" });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  component: () => <Outlet />,
});
